import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-case-number-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatDialogModule,
    MatTableModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    ScrollingModule,
  ],
  templateUrl: './case-number-dialog.component.html',
  styleUrl: './case-number-dialog.component.scss'
})
export class CaseNumberDialogComponent {
  caseData = this.data.caseList;
  displayedColumns: string[] = ['caseNumber', 'caseCategory', 'division', 'select'];
  selectedCase: any = null;

  constructor(
    public dialogRef: MatDialogRef<CaseNumberDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { caseList: any[] },
    private router: Router,
  ) { }

  onSelect(row: any) {
    this.caseData.forEach(r => {
      if (r !== row) r.selected = false;
    });
    this.selectedCase = row;
  }

  onOk() {
    this.dialogRef.close(this.selectedCase);
    this.dialogRef.afterClosed().subscribe(selectedCase => {
      if (selectedCase) {
        //console.log('Selected Case:', selectedCase);
        // Handle the selected case here (e.g., navigate or process)
        this.router.navigate(['/dashboard/documents-reception'], {
          queryParams: { caseNumber: selectedCase.caseNumber }
        });
      }
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

}
